import React, { useState, useEffect } from 'react';
import './Setting.css';
import './Changepass.css';
import './Bill.css';
import { getWithTokenAPI, putAPI, UploadDocument, postWithoutTokenAPI } from '../../util/Api';
import './Changepass.css';
import { useNavigate } from 'react-router-dom';
import Dashboardmy from '../Dashboard-component/Dashboard';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useSelector, useDispatch } from 'react-redux';
import { updateSpecificUserDetailsKeyinState } from '../../store/auth/action';

const AccountSettings = () => {
    const navigate = useNavigate();
    const [profileImage, setProfileImage] = useState(null);
    const accessToken = useSelector((state) => state.auth?.auth?._id);
    const dispatch = useDispatch();
    const [formErrors, setFormErrors] = useState({});

    const [userData, setUserData] = useState({
        name: '',
        email: '',
        phone_number: '',
        profile_image: '',
        address: {
            firstName: '',
            lastName: '',
            company: '',
            streetAddress: '',
            country: '',
            state: '',
            zipCode: '',
            email: '',
            phone: ''
        }
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!accessToken) {
            toast.error('Please login to access settings');
            navigate('/login');
            return;
        }
        fetchUserData();
    }, [accessToken]);

    const fetchUserData = async () => {
        try {
            setLoading(true);
            const response = await getWithTokenAPI(accessToken, `/user/find-particular?_id=${accessToken}`);
            if (response?.statusCode === 200 && response.data) {
                const user = response.data;
                setUserData({
                    name: user.name || '',
                    email: user.email || '',
                    phone_number: user.phone_number || '',
                    profile_image: user.profile_image || '',
                    address: {
                        firstName: user.firstName || '',
                        lastName: user.lastName || '',
                        company: user.company || '',
                        streetAddress: user.streetAddress || '',
                        country: user.country || '',
                        state: user.state || '',
                        zipCode: user.zipCode || '',
                        email: user.email || '',
                        phone: user.phone_number || ''
                    }
                });
                if (user.profile_image) {
                    setProfileImage(user.profile_image);
                }
            }
        } catch (error) {
            console.error('Error fetching user data:', error);
            toast.error('Failed to fetch user data');
            if (error?.response?.status === 401) {
                navigate('/login');
            }
        } finally {
            setLoading(false);
        }
    };

    const validateForm = () => {
        const errors = {};
        if (!userData.name.trim()) {
            errors.name = 'Name is required';
        }
        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleAccountSubmit = async (e) => {
        e.preventDefault();
        
        // Validate form before submission
        if (!validateForm()) {
            return;
        }

        try {
            const payload = {
                _id: accessToken,
                name: userData.name,
                email: userData.email
            };

            const response = await UploadDocument('/user/update', payload);

            if (response?.statusCode === 200) {
                // Update Redux store with new user name
                dispatch(updateSpecificUserDetailsKeyinState({
                    name: userData.name
                }));
                toast.success('Account details updated successfully');
                setTimeout(() => {
                    fetchUserData();
                }, 1000);
            } else {
                toast.error(response?.message || 'Failed to update account details');
                // Revert the name if update fails
                setTimeout(() => {
                    fetchUserData();
                }, 1000);
            }
        } catch (error) {
            console.error('Error updating account:', error);
            toast.error(error?.response?.data?.message || 'Failed to update account details');
            // Revert the name if update fails
            setTimeout(() => {
                fetchUserData();
            }, 1000);
            if (error?.response?.status === 401) {
                navigate('/login');
            }
        }
    };

    const handleImageChange = async (e) => {
        const file = e.target.files[0];
        if (file) {
            try {
                // Create a temporary URL for preview
                const previewUrl = URL.createObjectURL(file);
                setProfileImage(previewUrl);

                // Create FormData for file upload
                const formData = new FormData();
                formData.append('files', file);
                formData.append('path', 'media/');

                // Upload the image using postWithoutTokenAPI
                const response = await postWithoutTokenAPI('/files/upload', formData);
                if (response?.statusCode === 200 && response.data?.[0]?.file_url) {
                    // Update user profile with the new image URL
                    const updatePayload = {
                        _id: accessToken,
                        profile_image: response.data[0].file_url
                    };

                    const updateResponse = await UploadDocument('/user/update', updatePayload);
                    if (updateResponse?.statusCode === 200) {
                        toast.success('Profile image updated successfully');
                        // Update the profile image with the new URL
                        setProfileImage(response.data[0].file_url);
                        // Refresh user data to get the updated image
                        setTimeout(() => {
                            fetchUserData();
                        }, 1000);
                    } else {
                        toast.error('Failed to update profile image');
                        // Revert the preview if update fails
                        setProfileImage(userData.profile_image);
                    }
                } else {
                    toast.error('Failed to upload image');
                    // Revert the preview if upload fails
                    setProfileImage(userData.profile_image);
                }
            } catch (error) {
                console.error('Error uploading image:', error);
                toast.error('Failed to upload image');
                // Revert the preview if upload fails
                setProfileImage(userData.profile_image);
            }
        }
    };

    if (loading) {
        return <div className="loading">Loading...</div>;
    }

    return (
        <>
            <ToastContainer autoClose={3000} />
            <div className='show-content'>
                <Dashboardmy />

                <div className="account-wrapper">
                    <div className="account-header">
                        <h2>Account Settings</h2>
                    </div>

                    <div className="account-form-section">
                        <form className="account-form" onSubmit={handleAccountSubmit}>
                            <div className="input-group-my">
                                <label>Name</label>
                                <input
                                    type="text"
                                    placeholder="John"
                                    className='input-box-setting'
                                    value={userData.name}
                                    onChange={(e) => setUserData({ ...userData, name: e.target.value })}
                                    required
                                />
                                {formErrors.name && <span className="error-message">{formErrors.name}</span>}
                            </div>
                            <div className="input-group-my">
                                <label>Email</label>
                                <input
                                    type="email"
                                    placeholder="example@email.com"
                                    className='input-box-setting'
                                    value={userData.email}
                                    readOnly
                                    style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
                                    onChange={(e) => setUserData({ ...userData, email: e.target.value })}
                                />
                            </div>
                            <div className="input-group-my">
                                <label>Phone Number</label>
                                <input
                                    type="tel"
                                    placeholder="+1 234 567 890"
                                    className='input-box-setting'
                                    value={userData.phone_number}
                                    readOnly
                                    style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
                                />
                            </div>
                            <button 
                                type="submit" 
                                className="save-btn"
                                disabled={!userData.name.trim()} // Disable if name is empty
                            >
                                Save Changes
                            </button>
                        </form>

                        <div className="profile-section">
                            <div className="profile-image">
                                {profileImage ? (
                                    <img src={profileImage} alt="Profile Preview" className="profile-preview" />
                                ) : (
                                    <span></span>
                                )}
                            </div>

                            <input
                                type="file"
                                id="imageUpload"
                                accept="image/*"
                                onChange={handleImageChange}
                                style={{ display: 'none' }}
                            />

                            <label htmlFor="imageUpload" className="upload-btn">Choose Image</label>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AccountSettings;
